import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const GeoPage = lazy(() => import('../pages/geo/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const TourismPage = lazy(() => import('../pages/tourism/page'));

const PageLoader = () => (
  <div className="min-h-screen bg-ds-bg flex items-center justify-center">
    <div className="w-1 h-8 bg-ds-red animate-pulse" />
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<PageLoader />}><Home /></Suspense>,
  },
  {
    path: '/geo-aeo',
    element: <Suspense fallback={<PageLoader />}><GeoPage /></Suspense>,
  },
  {
    path: '/service-areas',
    element: <Suspense fallback={<PageLoader />}><ServiceAreasPage /></Suspense>,
  },
  {
    path: '/tourism-website-design',
    element: <Suspense fallback={<PageLoader />}><TourismPage /></Suspense>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
